import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { airtableEmbedUrl } from "../../helpers/airtableEmbed";
import type { AirtableEmbedIds } from "../../helpers/airtableEmbed";

const EMBED_SRC = "https://airtable.com/embed/apprWesJGBmsmfsWx/shrGuZgER2csPDSlm";

// Ids for this view's interface page and gallery element — see helpers/airtableEmbed.
const EMBED_IDS: AirtableEmbedIds = {
  pageId: "pagxWAPXmZ18UUbej",
  elementId: "pelgWu4vEJh3goMpr",
  queryContainerId: "pelscEjHj6rpJEB75",
};

export default function MonthlyViewPage() {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();

  // /app/monthly-view?rec=recXXXXXXXXXXXXXX opens that resource expanded.
  const src = airtableEmbedUrl(EMBED_SRC, EMBED_IDS, searchParams.get("rec"));

  // The embed can't be steered once loaded, so a different record means a new
  // iframe — show the spinner again while it loads.
  useEffect(() => setLoading(true), [src]);

  return (
    <main className="all-resources-page page">
      <div className="w-full h-[calc(100vh-100px)] relative">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
            <span className="loader"></span>
          </div>
        )}

        <iframe
          key={src}
          title="Monthly View"
          className="airtable-embed"
          src={src}
          frameBorder="0"
          width="100%"
          height="100%"
          style={{ background: "transparent", border: "1px solid var(--color-border-subtle)" }}
          onLoad={() => setLoading(false)}
        />
      </div>
    </main>
  );
}
